.root {
  --button-padding-x-xs: var(--mantine-spacing-md);
  --button-padding-x-sm: var(--mantine-spacing-lg);
  --button-padding-x-md: var(--mantine-spacing-xl);
  --button-padding-x-lg: calc(var(--mantine-spacing-xl) * 2);
  --button-padding-x-xl: calc(var(--mantine-spacing-xl) * 3);

  font-weight: 500;
  text-transform: uppercase;

  &:not([data-disabled="true"]) {
    &:active {
      /** TODO: use `variantColorResolver` function in theme.ts -- https://mantine.dev/styles/variants-sizes/#variantcolorresolver */
      outline: var(--mantine-spacing-xs) solid var(--mantine-color-primary-light);
    }

    &[data-variant="light"],
    &[data-variant="subtle"],
    &[data-variant="transparent"] {
      &:active {
        outline: var(--mantine-spacing-xxs) solid var(--button-color);
        outline-offset: var(--mantine-spacing-xxs);
      }
    }
  }

  &[data-variant="dashed"] {
    --button-color: light-dark(var(--mantine-color-black), var(--mantine-color-white));
    background-color: transparent;
    border: calc(0.0625rem * var(--mantine-scale)) dashed
      light-dark(var(--mantine-color-gray-3), var(--mantine-color-primaryDark-7));
    border-radius: var(--mantine-radius-default);
    height: auto;
    text-transform: none;
    transition:
      border-color 0.2s ease,
      background-color 0.2s ease;

    &:hover {
      border-color: light-dark(#8a9dd8, var(--mantine-color-secondary-5));
      background-color: light-dark(
        var(--mantine-color-primary-0),
        var(--mantine-color-primaryDark-7)
      );
    }
  }

  &[data-variant="outline"] {
    border-color: light-dark(var(--mantine-color-primary-7), var(--mantine-color-primary-1));
    color: light-dark(var(--mantine-color-primary-7), var(--mantine-color-primaryDark-3));
  }

  &[data-variant="light"] {
    background-color: light-dark(
      var(--mantine-color-primary-0),
      var(--mantine-color-primaryDark-7)
    );
  }
}
